const projectDueDates = {
  none: 1,
  oneWeek: 2,
  twoWeeks: 3,
  oneMonth: 4,
  twoMonths: 5,
  threeMonths: 6,
  sixMonths: 7,
  oneYear: 8,
};

export function getDueDate(dueDate: any) {
  const today = new Date();
  const returnDate = new Date(today);
  switch (dueDate) {
    case projectDueDates.oneWeek:
      returnDate.setDate(today.getDate() + 7);
      break;
    case projectDueDates.twoWeeks:
      returnDate.setDate(today.getDate() + 14);
      break;
    case projectDueDates.oneMonth:
      returnDate.setMonth(today.getMonth() + 1);
      break;
    case projectDueDates.twoMonths:
      returnDate.setMonth(today.getMonth() + 2);
      break;
    case projectDueDates.threeMonths:
      returnDate.setMonth(today.getMonth() + 3);
      break;
    case projectDueDates.sixMonths:
      returnDate.setMonth(today.getMonth() + 6);
      break;
    case projectDueDates.oneYear:
      returnDate.setFullYear(today.getFullYear() + 1);
      break;
    default:
      break;
  }
  return returnDate.toLocaleDateString('en-US');
}

export function stringDateComparator(date1: any, date2: any) {
  const date1Number = stringToComparabaleDate(date1);
  const date2Number = stringToComparabaleDate(date2);
  return dateComparator(date1Number, date2Number);
}

export function objectDateComparator(item1: any, item2: any) {
  const date1Number = itemToComparabaleDate(item1);
  const date2Number = itemToComparabaleDate(item2);
  return dateComparator(date1Number, date2Number);
}

function dateComparator(
  date1Number: number | Date | null,
  date2Number: number | Date | null,
) {
  if (
    (date1Number === null && date2Number === null) ||
    (date1Number as Date)?.getTime() == (date2Number as Date)?.getTime()
  ) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number > date2Number ? 1 : -1;
}

function itemToComparabaleDate(item: { dueDate: any }[] | null | undefined) {
  if (item === undefined || item === null || item.length == 0) {
    return null;
  }
  if (item.length >= 0) {
    const date1 = item[0].dueDate;
    return new Date(date1);
  }

  return new Date(item[0].dueDate);
}

function stringToComparabaleDate(
  date: string | number | Date | null | undefined,
) {
  if (date === undefined || date === null) {
    return null;
  }
  return new Date(date);
}
